import { render } from "./IFrame.vue?vue&type=template&id=6461205e&scoped=true"
import script from "./IFrame.vue?vue&type=script&lang=js"
export * from "./IFrame.vue?vue&type=script&lang=js"

import "./IFrame.vue?vue&type=style&index=0&id=6461205e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6461205e"]])

export default __exports__